import _extends from "@babel/runtime/helpers/esm/extends";
import { EModel } from './model';
// TODO danielmana: unify with EModel, which uses lowercase
// TODO danielmana: Figure out if we need to maintain keys with spaces ` `
export let EBaseModelType;
(function (EBaseModelType) {
  EBaseModelType["Activity"] = "Activity";
  EBaseModelType["Appointment"] = "Appointment";
  EBaseModelType["AppointmentType1"] = "AppointmentType";
  EBaseModelType["AppointmentType2"] = "Appointment Type";
  EBaseModelType["Availability"] = "Availability";
  EBaseModelType["Broadcast"] = "Broadcast";
  EBaseModelType["Campaign"] = "Campaign";
  EBaseModelType["ChatActivity"] = "ChatActivity";
  EBaseModelType["Diagnosis"] = "Diagnosis";
  EBaseModelType["Facility"] = "Facility";
  EBaseModelType["FeedbackResponse"] = "FeedbackResponse";
  EBaseModelType["FileUpload"] = "FileUpload";
  EBaseModelType["Followup"] = "Followup";
  EBaseModelType["Group"] = "Group";
  EBaseModelType["Hl7message"] = "Hl7message";
  EBaseModelType["Insurance"] = "Insurance";
  EBaseModelType["Intent"] = "Intent";
  EBaseModelType["Invoke"] = "Invoke";
  EBaseModelType["LumaBotFlow1"] = "LumaBotFlow";
  EBaseModelType["LumaBotFlow2"] = "LumaBot Flow";
  EBaseModelType["LumaBotFlowTemplate1"] = "LumaBotFlowTemplate";
  EBaseModelType["LumaBotFlowTemplate2"] = "LumaBot Flow Template";
  EBaseModelType["Message"] = "Message";
  EBaseModelType["MessageFailure"] = "MessageFailure";
  EBaseModelType["MessageTemplate"] = "MessageTemplate";
  EBaseModelType["Offer"] = "Offer";
  EBaseModelType["OutboundNumber"] = "OutboundNumber";
  EBaseModelType["OutboundReferral1"] = "OutboundReferral";
  EBaseModelType["OutboundReferral2"] = "Outbound Referral";
  EBaseModelType["Patient"] = "Patient";
  EBaseModelType["PatientForm1"] = "PatientForm";
  EBaseModelType["PatientForm2"] = "Patient Form";
  EBaseModelType["PatientFormTemplate1"] = "PatientFormTemplate";
  EBaseModelType["PatientFormTemplate2"] = "Patient Form Template";
  EBaseModelType["PatientMessageTemplate"] = "PatientMessageTemplate";
  EBaseModelType["Procedure"] = "Procedure";
  EBaseModelType["Provider"] = "Provider";
  EBaseModelType["Recall"] = "Recall";
  EBaseModelType["Referral"] = "Referral";
  EBaseModelType["Reminder"] = "Reminder";
  EBaseModelType["Schedule"] = "Schedule";
  EBaseModelType["Telehealth"] = "Telehealth";
  EBaseModelType["User1"] = "User";
  EBaseModelType["User2"] = "Staff";
  EBaseModelType["WaitingRoomPatient"] = "WaitingRoomPatient";
  EBaseModelType["Waitlist"] = "Waitlist";
})(EBaseModelType || (EBaseModelType = {}));
export const fieldsIBaseModel = {
  _id: {
    type: 'ID'
  },
  deleted: {
    type: 'Number'
  },
  createdAt: {
    type: 'Date'
  },
  updatedAt: {
    type: 'Date'
  },
  createdBy: {
    type: 'ID',
    ref: EModel.User
  },
  updatedBy: {
    type: 'ID',
    ref: EModel.User
  },
  deletedBy: {
    type: 'ID',
    ref: EModel.User
  },
  deletedAt: {
    type: 'Date'
  },
  __t: {
    type: 'Option',
    values: EBaseModelType,
    deprecated: true
  },
  __v: {
    type: 'Number',
    deprecated: true
  },
  id: {
    type: 'Text',
    deprecated: true
  },
  $fromSocket: {
    type: 'Boolean',
    deprecated: true
  },
  $toString: {
    type: 'Text',
    deprecated: true
  },
  $isDeleted: {
    type: 'Boolean',
    deprecated: true
  },
  $isPopulated: {
    type: 'Boolean',
    deprecated: true
  }
};
export const fieldsIBaseModelWithUser = _extends({}, fieldsIBaseModel, {
  user: {
    type: 'ID',
    ref: EModel.User
  }
});